export const settlementStatusMap = {
    Cancelled: "Cancelled",
    CashOut: "CashOut",
    Draw: "Void",
    HalfLost: "DeadHeatReduction",
    HalfWon: "DeadHeatReduction",
    Lost: "Lost",
    NonRunner: "Void",
    None: "Unknown",
    Open: "Open",
    PartialCashOut: "CashOut",
    Placed: "DeadHeatReduction",
    PladedDeadHeat: "DeadHeatReduction",
    Won: "Won",
    WonDeadHeat: "DeadHeatReduction",
};
export const displayBetStatusMap = {
    Cancelled: "Cancelled",
    CashOut: "CashOut",
    DeadHeatReduction: "Won",
    Open: "Open",
    Lost: "Lost",
    Void: "Void",
    Won: "Won",
    GhostWin: "GhostWin",
    EarlyExit: "EarlyExit",
    EarlyExitWin: "EarlyExitWin",
    Unknown: "",
};
export const defaultLoadingBetCardHeight = 162;
export const defaultLoadingBetCardsCount = 6;
export const defaultLoadingScreenHeight = defaultLoadingBetCardsCount * defaultLoadingBetCardHeight;
export const combinationItemsPerPage = 10;
export const mapLadderPercentageTypeToPicksInfo = {
    single: 1,
    double: 2,
    treble: 3,
    fourFold: 4,
    fiveFold: 5,
    sixFold: 6,
    sevenFold: 7,
    eightFold: 8,
    nineFold: 9,
    tenFold: 10,
    elevenFold: 11,
    twelveFold: 12,
    thirteenFold: 13,
    fourteenFold: 14,
    fifteenFold: 15,
    sixteenFold: 16,
    seventeenFold: 17,
    eighteenFold: 18,
    nineteenFold: 19,
    twentyPlusFold: 20
};
export const telemetry = {
    version: "2",
    page: "My Bets",
    clientType: "Web",
    network: {
        cashOutBet: {
            request: "WagerApiRequest",
            response: "WagerApiResponse",
            exception: "WagerApiException",
        },
        acceptNewOffer: {
            request: "WagerApiRequest",
            response: "WagerApiResponse",
            exception: "WagerApiException",
        },
        getBoostByBoostId: {
            exception: "BONUS_MANAGEMENT_FETCH_DKE_REWARDS_ERROR",
        },
        operationsUpdate: {
            request: "CashoutApiRequest",
            exception: "CashoutApiException",
        },
        informationsUpdate: {
            request: "CashoutApiRequest",
            exception: "CashoutApiException",
        },
        initialBetsPage: {
            request: "InitializeBetsPageRequest",
            response: "InitializeBetsPageResponse",
            exception: "InitializeBetsPageException"
        },
        nextBetsPage: {
            request: "BetsRequest",
            response: "BetsResponse",
            exception: "BetsException"
        },
        pushMessage: {
            request: "",
            response: "PushResponse",
            exception: "PushException"
        },
        unsubscribe: {
            request: "UnsubscribeRequest",
            response: "UnsubscribeResponse",
            exception: "UnsubscribeException"
        },
        socketConnecting: {
            request: "SocketConnecting",
            response: "SocketConnected",
            exception: "SocketFailedToConnect"
        },
        socketReconnecting: {
            request: "SocketReconnecting",
            response: "SocketReconnected",
            exception: "SocketFailedToReconnect"
        },
        socketClosed: {
            request: "SocketClosed",
            response: "SocketClosed",
            exception: ""
        },
        cashOutOperations: {
            request: "CashoutOperationsRequest",
            response: "CashoutOperationsResponse",
            exception: "CashoutOperationsException",
        },
        manualUnsubscribe: {
            request: "UnsubscribeRequest",
            response: "UnsubscribeResponse",
            exception: "UnsubscribeException"
        },
    },
    events: {
        customTrace: "CustomTrace",
        myBets: "MY_BETS_EVENT",
        myBetsError: "MY_BETS_LIST_ERROR",
        cashOut: "CashoutEvent",
        cashOutProcessing: "CashoutProcessEvent",
    },
    actions: {
        myBets: {
            loadMoreBets: "LoadMoreBets",
            openTab: "OpenTab",
            routeToLogin: "RouteToLogin",
            routeToSportsbook: "RouteToSportsbook",
            shareBet: "ShareBet",
            openBoostLadder: "OpenBoostLadder",
            openBoostMoreInfo: "OpenBoostMoreInfo",
            openOldBets: "OpenOldBets",
            tryingToParseBets: "TryingToParseBets"
        },
        cashOut: {
            initiateCashOut: "InitiateCashOut",
            confirmCashOut: "ConfirmCashOut",
            cancelCashOut: "CancelCashOut",
            newOfferReceived: "NewOfferReceived",
            acceptNewOffer: "AcceptNewOffer",
            declineNewOffer: "DeclineNewOffer",
            attempt: "Attempt",
            oddsChangeAfterUserInitiateCashout: "OddsChangeAfterUserInitiateCashout",
            immediateSuccess: "ImmediateSuccess",
            failure: "Failure",
            beginDelay: "BeginDelay",
            delayedFailure: "DelayedFailure",
            suspendedOnReturn: "SuspendedOnReturn",
            delayedSuccess: "DelayedSuccess",
            openRecheckLocationModal: "OpenRecheckLocationModal",
        }
    },
    trace: {
        cashOutFlow: "CashoutEvent:CashOutFlow",
        userConfirm: "CashoutEvent:UserConfirm",
        request: "CashoutEvent:Request",
        newOfferFlow: "CashoutEvent:NewOfferFlow",
        newOfferConfirm: "CashoutEvent:NewOfferConfirm",
        newOfferRequest: "CashoutEvent:NewOfferRequest",
    }
};
export const cashOutConfirmationResetTime = 3000; //in milliseconds
export const EETAG = 1;
//# sourceMappingURL=constants.js.map